
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class TeacherPaymentsGrid extends Serenity.EntityGrid<TeacherPaymentsRow, any> {
        protected getColumnsKey() { return TeacherPaymentsColumns.columnsKey; }
        protected getDialogType() { return TeacherPaymentsDialog; }
        protected getIdProperty() { return TeacherPaymentsRow.idProperty; }
        protected getInsertPermission() { return TeacherPaymentsRow.insertPermission; }
        protected getLocalTextPrefix() { return TeacherPaymentsRow.localTextPrefix; }
        protected getService() { return TeacherPaymentsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}